import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { useMicrosoftLogin } from 'LoginUI/hooks/useMicrosoftLogin';
import { useAppleLogin } from 'LoginUI/hooks/useAppleLogin';
import { usePasskeyLogin } from 'LoginUI/hooks/usePasskeyLogin';
import GoogleLoginButton from '../google/GoogleLoginButton';
import { MicrosoftLoginButton } from '../microsoft/MicrosoftLoginButton';
import AppleLoginButton from '../apple/AppleLoginButton';
import PasskeyLoginButton from '../passkey/PasskeyLoginButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const LoginOptions = ({
  onGoogleLoginClick,
  triggerReset,
  ssoRender,
  email,
  rememberLogin
}) => {
  const {
    loginWithMicrosoft
  } = useMicrosoftLogin({
    handleError: triggerReset,
    rememberLogin
  });
  const {
    loginWithApple
  } = useAppleLogin({
    handleError: triggerReset,
    rememberLogin
  });
  const {
    loginWithPasskey
  } = usePasskeyLogin({
    handleError: triggerReset,
    rememberLogin
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "200",
      marginBlockEnd: "400",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsx(View, {
        minInlineSize: "211px",
        children: /*#__PURE__*/_jsx(GoogleLoginButton, {
          onClick: onGoogleLoginClick
        })
      }), /*#__PURE__*/_jsx(View, {
        minInlineSize: "211px",
        children: /*#__PURE__*/_jsx(MicrosoftLoginButton, {
          onClick: loginWithMicrosoft
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "200",
      marginBlock: "400",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsx(View, {
        minInlineSize: "211px",
        children: /*#__PURE__*/_jsx(AppleLoginButton, {
          onClick: loginWithApple
        })
      }), /*#__PURE__*/_jsx(View, {
        minInlineSize: "211px",
        children: ssoRender()
      })]
    }), /*#__PURE__*/_jsx(PasskeyLoginButton, {
      onClick: () => loginWithPasskey(),
      disabled: email === ''
    })]
  });
};